import { serviceEndPoint } from "../utils/serviceEndpoint";

export async function login(token, action, userName, password) {
  let requestFormData = new FormData();
  requestFormData.append(
    "data",
    '{"token" : "' +
      token +
      '", "action" : "' +
      action +
      '", "data" : [{"userName":"' +
      userName +
      '","password":"' +
      password +
      '"}]}'
  );

  return fetch(serviceEndPoint.loginService, {
    method: "POST",
    body: requestFormData,
  }).then((response) => response.json());
}

export function getUserDetails(data) {
  const obj = {
    id: data[1].id,
    userName: data[1].userName,
    firstName: data[1].firstName,
    lastName: data[1].lastName,
    email: data[1].emailAddress,
    token: data[0].token,
    refeshToken: data[0].refreshToken,
    secretKey: "strive",
    jwtTimeOut: "",
    sessionTime: "",
  };
  var today = new Date();
  today.setMinutes(today.getMinutes() + 15);

  obj.sessionTime = today;
  obj.jwtTimeOut = today;
  return obj;
}

export async function fetchUserScope(token, userid, programId, roleId) {
  let requestFormData = new FormData();
  requestFormData.append(
    "data",
    '{"token" : "", "action" : "getUserScopeForFSS", "data" : [{"userId":' +
      userid +
      ',"programId":' +
      programId +
      ',"roleMapId":' +
      roleId +
      ',"isActive":' +
      '"Y"' +
      "}]}"
  );

  return fetch(serviceEndPoint.securityService, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
    },
    body: requestFormData,
  }).then((response) => response.json());
}

export const getMentorMenteeMapping = async (token, mentorId) => {
  const url = `${serviceEndPoint.mentorMenteeMappingService}/bymentorid/${mentorId}`;

  return await fetch(url, {
    method: "GET",
    headers: { Authorization: "Bearer " + token },
  })
    .then((response) => response.json())
    .catch((err) => err);
};

export async function getMenteeDetails(token, menteeIdList) {
  let requestFormData = new FormData();
  requestFormData.append(
    "data",
    '{"token" : "", "action" : "getUserDetialsByIdForFSS", "data" : ' +
      JSON.stringify(menteeIdList) +
      "}"
  );

  return fetch(serviceEndPoint.securityService, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
    },
    body: requestFormData,
  })
    .then((response) => response.json())
    .catch((err) => err);
}

export const getMeetingSchedulerData = async (mentorId, token) => {
  const url = `${serviceEndPoint.scheduleService}/fetchallrecordinquater/${mentorId}`;

  return await fetch(url, {
    method: "GET",
    headers: { Authorization: "Bearer " + token },
  })
    .then((response) => response.json())
    .catch((err) => err);
};

export const createMeetingScheduler = async (token, data) => {
  const url = `${serviceEndPoint.scheduleService}/classroomormentoring`;

  return await fetch(url, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .catch((err) => err);
};

export const updateMeetingSchedulerStatus = async (
  token,
  scheduleId,
  status
) => {
  const url = `${serviceEndPoint.scheduleService}/update/sessionstatus/${scheduleId}/${status}`;

  return await fetch(url, {
    method: "PATCH",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .catch((err) => err);
};

export const updateMeetingSchedulerStatusandBatchName = async (
  token,
  scheduleId,
  body
) => {
  const url = ` ${serviceEndPoint.scheduleService}/update/sessionstatusAndBtach/sessionId/${scheduleId}`;

  return await fetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });
};

export const updateMeetingSchedulerCount = async (token, scheduleId, data) => {
  const url = `${serviceEndPoint.scheduleService}/updatesessiondetails/${scheduleId}`;

  return await fetch(url, {
    method: "PATCH",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .catch((err) => err);
};

export const getObservationQuestions = async (token, programId) => {
  const url = `${serviceEndPoint.questionSetService}/observation/${programId}`;

  return await fetch(url, {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
    },
  })
    .then((response) => response.json())
    .catch((err) => err);
};

export const saveFeedback = async (token, data) => {
  const url = `${serviceEndPoint.answerSetService}/savingfeedback`;

  return await fetch(url, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .catch((err) => err);
};

export const updateFeedback = async (token, data) => {
  const url = `${serviceEndPoint.answerSetService}/actionitems/updateanswer`;

  return await fetch(url, {
    method: "PATCH",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .catch((err) => err);
};

export const getMentoringActionItem = async (token, programId) => {
  const url = `${serviceEndPoint.questionSetService}/action_items/${programId}`;

  return await fetch(url, {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
    },
  })
    .then((response) => response.json())
    .catch((err) => err);
};

export const getActionItemsForMentoring = async (token, menteeId) => {
  const url = `${serviceEndPoint.answerSetService}/actionitems/${menteeId}`;

  return await fetch(url, {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
    },
  })
    .then((response) => response.json())
    .catch((err) => err);
};

export const getRemarkAnswer = async (token, menteeId, questionId) => {
  const url = `${serviceEndPoint.answerSetService}/mentorremarks/${menteeId}/${questionId}`;

  return await fetch(url, {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
    },
  })
    .then((response) => response.json())
    .catch((err) => err);
};

/// fetch mentee dashboard scrore
export async function getMenteeScore(token, menteeIdList) {
  const url = `${serviceEndPoint.answerSetService}/dashboard`;

  return await fetch(url, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(menteeIdList),
  })
    .then((response) => response.json())
    .catch((err) => err);
}

export const getAllMentorActivities = async (token) => {
  const url = `${serviceEndPoint.FssSupport}/getAll`;
  return await fetch(url, {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
    },
  })
    .then((response) => response.json())
    .catch((err) => err);
};

export const SaveFssSupport = async (token, formData) => {
  const url = `${serviceEndPoint.FssSupport}/saveMentorActivityRecord`;

  return await fetch(url, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .catch((err) => err);
};

export const getActivitiesByMentorId = async (token, mentorId) => {
  const url = `${serviceEndPoint.FssSupport}/getByMentorId/${mentorId}`;
  return await fetch(url, {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
    },
  })
    .then((response) => response.json())
    .catch((err) => err);
};

export const uploadDocument = async (
  documentType,
  documentName,
  base64File,
  userId,
  token
) => {
  let requestFormData = new FormData();

  const typeOfDocument = "FSS";

  requestFormData.append(
    "data",
    '{"token" : "", "action" : "captureDocDetails", "data" : [{"dbUserId":' +
      0 +
      ',"engagementId":' +
      0 +
      ',"documentType":"' +
      documentType +
      '","typeOfDocument":"' +
      typeOfDocument +
      '","documentName":"' +
      documentName +
      '","base64File":"' +
      base64File +
      '","createdBy":"' +
      userId +
      '","updatedBy":"' +
      userId +
      '"}]}'
  );
  const url = serviceEndPoint.documentService;
  return await fetch(url, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
    },
    body: requestFormData, // Send FormData with appended data
  })
    .then((response) => response.json())
    .catch((err) => err);
};

export const downloadDocument = async (docId, token) => {
  let formData = new FormData();
  formData.append(
    "data",
    '{"token" : "", "action" : "downloadDocument", "data" : [{"basicDocId":' +
      docId +
      "}]}"
  );

  const url = serviceEndPoint.documentService;
  fetch(url, {
    method: "post",
    headers: {
      Authorization: "Bearer " + token,
    },
    body: formData,
  })
    .then((response) => response.json())
    .then((jsondata) => {
      let jsonobjects = JSON.parse(jsondata.data);
      var url =
        serviceEndPoint.downloadDocumentService +
        jsonobjects[0].documentPath +
        "";
      window.open(url, "_blank");
    })
    .catch((err) => {
      console.log(err);
    });
};
export const getBatchDetails = async (token, userId) => {
  try {
    let requestFormData = new FormData();
    requestFormData.append(
      "data",
      JSON.stringify({
        token: "",
        action: "getAssignedActiveBatches",
        data: [
          {
            domainFacilitator: userId,
          },
        ],
      })
    );

    const response = await fetch(serviceEndPoint.batchDetailService, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: requestFormData,
    });

    const result = await response.json();
    console.log("Raw result:", result);

    if (result.status === "success" && result.data) {
      const batchArray =
        typeof result.data === "string" ? JSON.parse(result.data) : result.data;
      return batchArray.filter(
        (batch) => batch.isActive === "Y" && !!batch.courseId
      );
    } else {
      return [];
    }
  } catch (error) {
    console.error("Error fetching batch details:", error);
    return [];
  }
};

export const getModuleDetails = async (token, courseId) => {
  try {
    let requestFormData = new FormData();
    requestFormData.append(
      "data",
      JSON.stringify({
        token: "",
        action: "fetchCourseModules",
        data: [
          {
            courseId: courseId,
          },
        ],
      })
    );

    const response = await fetch(`${serviceEndPoint.moduleService}/modules`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: requestFormData,
    });

    const result = await response.json();
    if (result.status === "success" && result.data) {
      const moduleArray =
        typeof result.data === "string" ? JSON.parse(result.data) : result.data;

      // Correct mapping based on your response keys: id and module
      return moduleArray.map((mod) => ({
        id: mod.id,
        name: mod.module,
      }));
    } else {
      console.warn("Invalid response format or no module data found.");
      return [];
    }
  } catch (error) {
    console.error("Error fetching module details:", error);
    return [];
  }
};

export const FSSFacilitatorsmanagement = async (token, centerId) => {

  const url =
    `${serviceEndPoint.facilitatoruser}/facilitators`;

  return await fetch(url, {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
    },
  })
    .then((response) => response.json())
    .catch((err) => err);
};


export const getActiveMentors = async (token) => {
  const url = `${serviceEndPoint.facilitatoruser}/active-mentors`;

  return await fetch(url, {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
    },
  })
    .then((response) => response.json())
    .catch((err) => err);
};
export const getFscMenteeDetails = async (token, centerId) => {
  const url = `${serviceEndPoint.facilitatoruser}/fsc-facilitators/center/${centerId}`;

  return await fetch(url, {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
    },
  })
    .then((response) => response.json())
    .catch((err) => err);
};


// ===============================120926====================
export const getActiveFscList = async (token) => {
  const url = `${serviceEndPoint.facilitatoruser}/fsc-list`;

  return await fetch(url, {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
    },
  })
    .then((response) => response.json())
    .catch((err) => err);
};

export const createFscFacilitatorMapping = async (token, data) => {
  const url = `${serviceEndPoint.facilitatoruser}`;

  return await fetch(url, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .catch((err) => err);
};

export const deactivateFscFacilitatorMapping = async (
  token,
  mappingId,
  updatedBy // <--- Receive updatedBy
) => {
  const url = `${serviceEndPoint.facilitatoruser}/deactivate/${mappingId}`;

  return await fetch(url, {
    method: "PUT",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ updatedBy: updatedBy }), // <--- Pass in Body
  })
    .then((response) => response.json())
    .catch((err) => err);
};
export const assignFacilitatorToFsc = async (token, data) => {
  const url = `${serviceEndPoint.facilitatoruser}/fsc/assign-facilitator`;

  return await fetch(url, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .catch((err) => err);
};
export const getFscFacilitators = async (token) => {
  const url = `${serviceEndPoint.facilitatoruser}/fsc-facilitators`;

  return await fetch(url, {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .catch((err) => err);
};


// export const getAvailableFacilitatorsForFscCreation = async (token) => {
//   const url = `${serviceEndPoint.facilitatoruser}/facilitators/available-for-fsc-creation`;

//   return await fetch(url, {
//     method: "GET",
//     headers: {
//       Authorization: "Bearer " + token,
//       "Content-Type": "application/json",
//     },
//   })
//     .then((response) => response.json())
//     .catch((err) => err);
// };





export const getAvailableFacilitatorsForFscMapping = async (token,centerId) => {
  const url = `${serviceEndPoint.facilitatoruser}/facilitators/available-for-fsc-mapping/center/${centerId}`;

  return await fetch(url, {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .catch((err) => err);
};

export const getActiveCentersByModel = async (token) => {
  try {
    const response = await fetch(
      `${serviceEndPoint.centerService}/active-by-model`,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    );

    return await response.json();
  } catch (error) {
    console.error("Error fetching active centers:", error);
    throw error;
  }
};

export const getFacilitatorsByCenter = async (
  token,
  centerId
) => {
  try {
    const response = await fetch(
      `${serviceEndPoint.facilitatoruser}/facilitators/center/${centerId}`,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    );

    return await response.json();
  } catch (error) {
    console.error(
      "Error fetching facilitators by center:",
      error
    );
    throw error;
  }
};


export const getFacilitatorsForFscByCenter = async (
  token,
  centerId
) => {
  try {
    const response = await fetch(
      `${serviceEndPoint.facilitatoruser}/facilitators/available-for-fsc-creation/center/${centerId}`,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    );

    return await response.json();
  } catch (error) {
    console.error(
      "Error fetching facilitators by center:",
      error
    );
    throw error;
  }
};
// 1. Create User Center Role Map
export const createUserCenterRoleMap = async (token, payload) => {
  const url = serviceEndPoint.FSCCreation; // Local URL "http://localhost:8080/users"

  const formData = new URLSearchParams();
  formData.append(
    "data",
    JSON.stringify({
      action: "createUserCenterRoleMap",
      data: [payload],
    })
  );

  return await fetch(url, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: formData.toString(),
  })
    .then((response) => response.json())
    .catch((err) => err);
};

// 2. Deactivate User Center Role Map
export const deactivateUserCenterRoleMap = async (token, payload) => {
  const url = serviceEndPoint.FSCdeactivation; // Local URL "http://localhost:8080/users"

  const formData = new URLSearchParams();
  formData.append(
    "data",
    JSON.stringify({
      action: "deactivateUserCenterRoleMap",
      data: [payload],
    })
  );

  return await fetch(url, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: formData.toString(),
  })
    .then((response) => response.json())
    .catch((err) => err);
};